import { css } from '@emotion/react';
import { UnitSystem } from '~/_shared/types/googleMaps/googleMaps.types';
import { convertDistanceToUnitSystem } from '~/_shared/utils/distance/distance.helpers';
import type { ReportDemographicData } from '~/exportReport/exportReportData.helpers';
import { ExportReportType } from '~/exportReport/exportReportType';
import type { ReportTableColumn } from '~/exportReport/table/ReportTable.model';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import { ExportReportTemplateRendererComponent } from '~/exportReport/templateRenderer/exportReportTemplateRenderer.component';
import type { ExportReportRadiusParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

const wrapperStyle = css({
  padding: 20,
  maxWidth: 1000,
  margin: '0 auto',
});

const googleMapStyle = css({
  width: '50%',
  aspectRatio: '386 / 234',
});

type MapExportReportPreviewRadiusProps = Readonly<{
  params: ExportReportRadiusParams;
  template: ReportTemplate;
  tableColumns: ReadonlyArray<ReportTableColumn>;
  getDemographicLabel: (demographicId: string) => string | null;
  getDemographicData: (columnId: string, demographicId: string) => ReportDemographicData | null;
  isLoading: boolean;
}>;

export const MapExportReportPreviewRadiusComponent = ({
  template, params, tableColumns, getDemographicData, getDemographicLabel, isLoading,
}: MapExportReportPreviewRadiusProps) => {
  return (
    <div css={wrapperStyle}>
      <ExportReportTemplateRendererComponent
        template={template}
        tableColumns={tableColumns}
        summaryProps={{
          latLng: {
            lat: params.data.center.lat,
            lng: params.data.center.lng,
          },
          heading: params.data.title,
        }}
        mapProps={{
          center: params.data.center,
          css: googleMapStyle,
          type: ExportReportType.Radius,
          radiusInMeters: convertDistanceToUnitSystem({
            distance: params.data.radius,
            currentUnitSystem: params.data.unit,
            targetUnitSystem: UnitSystem.metric,
          }) * 1000,
        }}
        getDemographicLabel={getDemographicLabel}
        getDemographicData={getDemographicData}
        isLoading={isLoading}
      />
    </div>
  );
};
